import React from "react";

const Home = () => {
  return (
    <div className="container-fluid">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Overview</div>
              <h2 className="page-title">Dashboard</h2>
            </div>

            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <span className="d-none d-sm-inline">
                  <a href="#" className="btn btn-1">
                    {" "}
                    New view{" "}
                  </a>
                </span>
                <a href="#" className="btn btn-primary btn-5 d-none d-sm-inline-block" data-bs-toggle="modal" data-bs-target="#modal-report">
                  Create new report
                </a>
                <a href="#" className="btn btn-primary btn-6 d-sm-none btn-icon" data-bs-toggle="modal" data-bs-target="#modal-report" aria-label="Create new report"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
